import Vuex from "vuex";
import userVUEX from "./modules/userVUEX.js";
import assetVUEX from "./modules/assetVUEX";
import courseVUEX from "./modules/courseVUEX.js";
import candidatefilterVUEX from "./modules/candidatefilterVUEX.js";

export default new Vuex.Store({
	state: {},
	getters: {
		accessToken: (state) => state.userVUEX.accessToken,
		refreshToken: (state) => state.userVUEX.refreshToken,
		userDetails: (state) => state.userVUEX.userDetails,
	},
	mutations: {},
	actions: {},
	modules: {
		userVUEX,
		assetVUEX,
		courseVUEX,
		candidatefilterVUEX
	},
});
